import { Cpu, Github, Twitter, ExternalLink } from "lucide-react";

export function Footer() {
  return (
    <footer className="relative border-t border-aox-cyan/20 py-12 px-4 lg:px-8 bg-aox-bg">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 grid place-items-center border border-aox-cyan/50 clip-chamfer bg-aox-cyan/10">
            <Cpu size={20} className="text-aox-cyan" />
          </div>
          <div>
            <div className="font-display font-extrabold text-white">AI MICK</div>
            <div className="font-mono-aox text-[10px] uppercase tracking-[0.3em] text-aox-green">
              AOX Blockchain · Super AI Bot
            </div>
          </div>
        </div>

        <p className="font-mono-aox text-xs text-slate-500 text-center">
          Become a hoodie, protect the blockchain, start mining AOX Bucks today.
        </p>

        <div className="flex items-center gap-4">
          <a
            href="https://hoodies-marketplace.preview.emergentagent.com/#ledger"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-aox-green hover:text-aox-cyan transition-colors font-semibold text-sm"
            data-testid="footer-aox-ledger"
          >
            AOX Ledger <ExternalLink size={14} />
          </a>
          <span className="font-display text-aox-green font-bold text-lg italic">cantina</span>
          <a href="#welcome" className="text-aox-cyan/50 hover:text-aox-cyan transition-colors" data-testid="footer-twitter">
            <Twitter size={18} />
          </a>
          <a href="#welcome" className="text-aox-cyan/50 hover:text-aox-cyan transition-colors" data-testid="footer-github">
            <Github size={18} />
          </a>
        </div>
      </div>
    </footer>
  );
}
